export interface RuntimeConfig {
  backendEnv?: 'local' | 'go-dev' | 'go-prod' | 'wf-prod';
  sentryDsn?: string;
  sentryEnvironment?: string;
}

function loadRuntimeConfig(): RuntimeConfig {
  const el = document.getElementById('runtime-config');
  if (!el?.textContent) {
    throw new Error(
      'Runtime config not found. Ensure <script type="application/json" id="runtime-config"> exists in index.html.',
    );
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(el.textContent);
  } catch (e) {
    throw new Error(`Failed to parse runtime config: ${e instanceof Error ? e.message : e}`);
  }

  // Nothing in here is load-bearing any more — the API and the auth flow are
  // same-origin, so a missing injection can no longer point the app at the wrong
  // deployment. It only drives the ribbon and Sentry.
  //
  // Still fail loudly on a missing injection, which is what vite.config.ts
  // promises when it leaves the placeholder in a build: the placeholder is the
  // JSON string "__RUNTIME_CONFIG__", so it parses, and without this check it
  // would sail through the cast and quietly ship a deploy with no Sentry and no
  // ribbon. A target's config can legitimately be empty ({} for go-prod), so the
  // shape is all there is to assert.
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
    throw new Error('Runtime config was not injected: expected a JSON object');
  }
  return parsed as RuntimeConfig;
}

export const runtimeConfig = loadRuntimeConfig();
